<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考试名称:">
          <el-select v-model="listQuery.exam_id" clearable placeholder="请选择">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 折线图 -->
    <div class="chart" id="chart">

    </div>
    <div>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column label="序号">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="考试项目">
        </el-table-column>
        <el-table-column   label="考试限时">
          <template slot-scope="scope">
            {{scope.row.mins}}分钟
          </template>
        </el-table-column>
        <el-table-column prop="timeAvg" label="平均耗时">
        </el-table-column>
        <el-table-column prop="scoreAvg" label="平均成绩">
        </el-table-column>
        <el-table-column prop="studentQuantity" label="考试人数">
        </el-table-column>
        <el-table-column prop="qualifiedPass" label="合格率">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <i class="el-icon-search" @click="handleEdit(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>

    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                examList: [],
                avgdata: [],
                subjectStr: [],
                studentScoreStr: [],
                scoreAvgStr: [],
                subStr: [],
                listQuery: {
                    page: 1,
                    per_page: 20
                },
                tableData: []
            };
        },
        computed: {},
        created() {
        },
        mounted() {
            this.getData();
            window.addEventListener('resize', () => {
                this.$echarts.init(document.getElementById('chart')).resize()
            })

        },
        methods: {
            search() {
                this.listQuery.page = 1;
                this.getData()
            },
            // 获取全部的课程列表
            getData() {
                this.$http.singleExamAnalysis(this.listQuery)
                    .then(res => {
                        this.examList = res.data.examlist;
                        this.tableData = res.data.data;
                        var standardStr = res.data.standardStr.split(",");
                        var scoreAvgStr = res.data.scoreAvgStr.split(",");
                        this.getline(standardStr, scoreAvgStr)
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleEdit(scope) {
                this.$router.push({
                    name: 'subjectScoreDetail', query: {
                        exam_id: this.listQuery.exam_id,
                        subject_id: scope.subjectId,
                        sign: 'subjects',
                        subject: scope.name
                    }
                })
            },
            //构建图标
            getline(standardStr, scoreAvgStr) {
                let chart = this.$echarts.init(document.getElementById('chart'))
                // 绘制图表
                chart.setOption({
                    tooltip: {
                        trigger: "axis"
                    },
                    legend: {
                        orient: 'horizontal', // 'vertical'
                        x: 'right', // 'center' | 'left' | {number},
                        y: 0, // 'center' | 'bottom' | {number}
                        padding: 40,
                        data: ["平均成绩"]
                    },
                    calculable: false,
                    xAxis: [{
                        type: "category",
                        data: standardStr
                    }],
                    yAxis: [{
                        type: "value"
                    }],
                    series: [
                        {
                            name: "平均成绩",
                            type: "bar",
                            data: scoreAvgStr
                        }]
                });
            }
        },
    };
</script>

<style scoped lang="less">

  .chart {
    width: 100%;
    height: 300px;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/page/statisticsManage/singleExam.vue